import { Card, CardContent, Grid, Typography } from "@mui/material";
import type { RegimeItemProps } from "./types/RegimeItemProps";

export function RegimeItem({ name, description, icon: IconComponent }: RegimeItemProps) {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ marginBottom: 3 }}>
      <Card
        elevation={0}
        sx={{
          height: "100%",
          textAlign: "center",
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          paddingY: 2,
          backgroundColor: "white",
        }}
      >
        <CardContent>
          <IconComponent
            sx={{
              color: "primary.main",
              fontSize: "3.5rem",
              marginBottom: 2,
            }}
          />

          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: 1,
            }}
          >
            {name}
          </Typography>

          <Typography variant="body2">{description}</Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
